import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';


import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

import FormControl from '@mui/material/FormControl';

import FormLabel from '@mui/material/FormLabel';

import Breadcrumbs from '@mui/material/Breadcrumbs';

import AddIcon from '@mui/icons-material/AddCircle';

import DepotGestion from 'components/Shared/DepotGestion';

import DepotGestionSelect from 'components/Shared/DepotGestionSelect';
import { green } from '@mui/material/colors';


const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },


    formContent: {
        display: 'flex',
        flexDirection: 'column'
    },


    formControl: {
        maxWidth: 300
    },

    formControl2: {
        paddingLeft: '16px'
    },

    transporteurCompteContainer: {
        display: 'flex',
        alignItems: 'baseline'
    },

    transporteurCompteItem: {
        alignSelf: 'baseline'
    },
    

    removeIcon: {
        color: 'red'
    },
    addIcon: {
        margin: '16px',
        color: 'green'
    },

    buttonControl: {
        margin: '8px 0px 8px 16px'
    },

    buttonControlTransporteursSecurite: {
        margin: '8px 16px 8px 16px'
    },

    chip: {
        margin: '8px 8px 8px 0px'
    },
    listElement: {
        margin: 10,
        padding: '4px 8px 4px 8px'
    },

    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },

    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column'
    },

    containerPilotes: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row'
    },

    containerTransporteursSecurite: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        padding: 8
    },

    containerDrop: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        minHeight: '100px'
    },

    containerLeft: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        marginRight: theme.spacing(1)
    },


    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    },

    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },

    table: {
        minWidth: 700
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },

    link: theme.style.link,
    

    guTransit: {
        color: green[500]
    },

    guMirror: {
        color: green[500]
    },



    button: {
        margin: theme.spacing(1)
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    rightIcon: {
        marginLeft: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    }
});



class AdministrationTransporteurCompte extends React.Component {
             

    render() {
        let { classes,
            selectedTransporteur, transporteurCompte,
            onChange, onClickSave,
            isPatching, sauvegardable,
            depotGestionIndex, onClickAddDepot, onClickRemoveDepot, setDepotGestionIndex 
        } = this.props;
                
        return (
            <React.Fragment>



                {selectedTransporteur && transporteurCompte && (
                    <div className={classes.root}>

                        <Helmet>
                            <title>{`Transporteur : ${selectedTransporteur.code}`}</title>
                        </Helmet>

                        <Typography gutterBottom variant="h5">
                            Édition du compte {transporteurCompte.id} du transporteur : {selectedTransporteur.code} 
                        </Typography>


                        <Breadcrumbs separator="›" arial-label="breadcrumb">
                            <Link to={`/administration/transporteurs/`} className={classes.link}>
                                <Typography variant="button">
                                    Transporteurs
                                </Typography>
                            </Link>

                            <Link to={`/administration/transporteurs/${selectedTransporteur.id}`} className={classes.link}>
                                <Typography variant="button">
                                    {selectedTransporteur.code}
                                </Typography>
                            </Link>

                            <Link to={`/administration/transporteurs/${selectedTransporteur.id}/comptes`} className={classes.link}>
                                <Typography variant="button">
                                    Comptes
                                </Typography>
                            </Link>

                            <Typography color="textPrimary">{transporteurCompte.id}</Typography>
                        </Breadcrumbs>


                        <Paper className={classes.paper}>
                            
                            <div className={classes.formContent}>

                                <FormControl margin="normal" className={classes.formControl}>
                                    <FormLabel component="legend" required>Compte</FormLabel>
                                    <TextField
                                        id="compte"
                                        name="compte"
                                        placeholder="Saisir un identifiant de compte"
                                        value={transporteurCompte.compte}
                                        onChange={onChange}
                                    />
                                </FormControl>

                                <FormControl margin="normal" className={classes.formControl}>
                                    <FormLabel component="legend">Login</FormLabel>
                                    <TextField
                                        id="login"
                                        name="login"
                                        placeholder="Saisir un login"
                                        value={transporteurCompte.login}
                                        onChange={onChange}
                                    />
                                </FormControl>

                                <FormControl margin="normal" className={classes.formControl}>
                                    <FormLabel component="legend">Mot de passe</FormLabel>
                                    <TextField
                                        id="motPasse"
                                        name="motPasse"
                                        placeholder="Saisir un mot de passe"
                                        value={transporteurCompte.motPasse}
                                        onChange={onChange}
                                    />
                                </FormControl>


                                <FormControl margin="normal" className={classes.formControl}>
                                    <FormLabel component="legend">Email de contact</FormLabel>
                                    <TextField
                                        id="email"
                                        name="email"
                                        placeholder="Saisir un email de contact"
                                        value={transporteurCompte.email}
                                        onChange={onChange}
                                    />
                                </FormControl>


                                <FormControl margin="normal">
                                    <FormLabel component="legend">Dépôts gestion</FormLabel>
                                
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>

                                        {transporteurCompte.depotsGestion.map((dg, index) => {
                                            return (
                                                <FormControl key={index} className={classes.chip}>
                                                    <DepotGestion depotGestion={dg} format="deletablechip" onDelete={(e) => onClickRemoveDepot(index)} />
                                                </FormControl>
                                            );
                                        })}
                                    </div>
                                </FormControl>

                                <FormControl margin="normal" className={classes.formControl}>
                                    <DepotGestionSelect value={depotGestionIndex} onChange={e => setDepotGestionIndex(e.target.value)} all={false} isRequired={false} autoFocus={false} label="Sélectionner un dépôt :"/>

                                    <Button variant="contained" size="small" className={classes.button} onClick={onClickAddDepot}>
                                        <AddIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                                        Ajouter ce dépot
                                        </Button>
                                </FormControl>

                            </div>


                        </Paper>


                        <div className={classes.actionContainer} >

                            <Link to={`/administration/transporteurs/${selectedTransporteur.id}/comptes`}>
                                <Button
                                    className={classes.buttonControl}
                                    disabled={!sauvegardable || isPatching}
                                    onClick={onClickSave}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Enregistrer
                                    {isPatching === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </Button>
                            </Link>
                            <Link to={`/administration/transporteurs/${selectedTransporteur.id}/comptes`}>
                                <Button className={classes.buttonControl} color="primary" >
                                    Annuler
                                </Button>
                            </Link>
                        </div>



                    </div>
                )}


            </React.Fragment>


        );
    }
}

AdministrationTransporteurCompte.propTypes = {
    classes: PropTypes.object.isRequired,
    onClickSave: PropTypes.func.isRequired,

    onClickAddDepot: PropTypes.func.isRequired,
    onClickRemoveDepot: PropTypes.func.isRequired,
    

    onChange: PropTypes.func.isRequired,

    sauvegardable: PropTypes.bool.isRequired,
    isPatching: PropTypes.bool.isRequired,
    selectedTransporteur: PropTypes.object
};

export default withStyles(styles)(AdministrationTransporteurCompte);